import React from 'react';
import PropTypes from 'prop-types';
import useNotify from '../../hooks/useNotify';
import { Box } from 'rebass';

export type AddressData = {
  street1: string;
  street2?: string | null;
  city: string;
  state: string;
  zip: string;
  zipExt?: string | null;
  latitude?: number | null;
  longitude?: number | null;
};

export type ActionBarProps = {
  address: AddressData;
};

/**
 * @component
 */
const Address: React.FC<ActionBarProps> = ({
  address: { street1, street2, city, state, zip, zipExt, latitude, longitude },
}) => {
  const { showSuccess } = useNotify();

  const parts = [street1];
  if (street2) {
    parts.push(street2);
  }
  parts.push(`${city}, ${state} ${zip}`);

  // const mapsApiUrl = `https://www.google.com/maps/search/?api=1&query=${parts
  //   .map(encodeURIComponent)
  //   .join(',')}`;

  return (
    <Box
      // title="Open in Google Maps"
      // href={mapsApiUrl}
      // target="_blank"
      // rel="noopener noreferrer"
      sx={{
        cursor: 'pointer',
        ':hover': {
          color: 'primary',
        },
      }}
      title="Copy to clipboard"
      onClick={() => {
        navigator.clipboard.writeText(parts.join('\n').toString());
        showSuccess(`Address copied to clipboard`, 3000);
      }}
    >
      {street1}
      <br />
      {street2 && (
        <>
          {street2}
          <br />
        </>
      )}
      {city}, {state} {zip}
      {zipExt && `-${zipExt}`}
    </Box>
  );
};

Address.propTypes = {
  address: PropTypes.shape({
    street1: PropTypes.string.isRequired,
    street2: PropTypes.string,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    zip: PropTypes.string.isRequired,
    zipExt: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }).isRequired,
};

export default Address;
